// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__jipcj","name":"ConsentHeader_name__1uwx2","birthday":"ConsentHeader_birthday__33zsq","skeleton":"ConsentHeader_skeleton__3_G0m"};